import { eventBus } from 'EventBus/';
import { pushEvent } from '../../utils/datalayer';

const NAVIGATION = '.header-nav';
const NAV_PANELS = '.header-nav__category-panel';

const BURGER_BTN = 'nav-burger';
const MY_ACCOUNT_BTN = 'nav-my-account';
const SEARCH_BTN = 'nav-search';

const NAV_BUTTONS = 'button.header-nav__nav-button';
const PANEL_CATEGORY = '--category';
const PANEL_SUBCATEGORY = '--sub-category';
const SEARCH_PANEL = '.header-search';
const SEARCH_INPUT = '#nav-search-query';

const ARIA_EXPANDED = 'aria-expanded';
const ARIA_HIDDEN = 'aria-hidden';

const OPEN_NAV = 'headernav::openNav';
const TOGGLE_PANEL = 'headernav::togglePanel';
const TOGGLE_SEARCH = 'headernav::toggleSearch';

const SEARCH_ICON_HREF = '#search';
const CLOSE_ICON_HREF = '#close';

const OPEN = '--open';
const CLOSING = '--closing';
const ACTIVE = '--active';
const BODY = 'body';

const DEFAULT_SEARCH_OPEN_LABEL = 'Search';
const DEFAULT_SEARCH_CLOSED_LABEL = 'Close (X)';

let tabletMediaQuery = '(min-width: 64rem)'; // 1024px
let lastChild;

const emitEvent = (type, index = null) => {
  eventBus.$emit(type, index);
};

if(window.matchMedia(tabletMediaQuery).matches) {
  if(document.getElementById("sliderprev")) {
    document.getElementById("sliderprev").style.display = "none";
  }
  if(document.getElementById("slidernext")) {
    document.getElementById("slidernext").style.display = "none";
  }
  if(document.getElementById("menuslider")) {
    document.getElementById("menuslider").removeAttribute("v-slider",undefined);
  }  
}else{
  if(document.getElementById("menuslider")) { 
    document.getElementById("menuslider").setAttribute("v-slider",undefined);
  }
}
const openMenu = (fromBurger = false, el) => {
  let openSubCategory = null;
  // Close Search Menu if it's open
  if (document.querySelector(SEARCH_PANEL)?.classList.contains(OPEN)) {
    toggleSearchClosed();
  }
  if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
    if(!window.matchMedia(tabletMediaQuery).matches) {
      return;
    }
  }
  document.querySelector(BODY)?.classList.add('navOpen');
  if (fromBurger) {
    document.querySelector(NAVIGATION)?.classList.add(OPEN, ACTIVE);
    if (document.body.classList.contains('isUsingKeyboard')) {
      document.querySelector(NAVIGATION)?.querySelector('BUTTON')?.focus();
    }
  } else {
    document.querySelector(NAVIGATION)?.classList.add(OPEN);
    document.querySelector(".header")?.classList.add(OPEN);
    if (el?.classList.contains(PANEL_CATEGORY) || getCategoryTrigger(el)) {
      let navItem = el.closest('LI');
      let firstSubCat = navItem?.querySelector(`BUTTON.${PANEL_SUBCATEGORY}`);

      openSubCategory = firstSubCat;
    }
  }
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, true);
  document.querySelector('main')?.setAttribute(ARIA_HIDDEN, true);
  document.querySelector('footer')?.setAttribute(ARIA_HIDDEN, true);
  emitEvent(OPEN_NAV, { status: true, fromBurger });

  return openSubCategory;
};

const deactivatePanels = (subcatOnly = false) => {
  const deactivateElement = (el) => {
    if (el.tagName === 'BUTTON') {
      el?.setAttribute(ARIA_EXPANDED, false);
    } else {
      el?.classList.remove(ACTIVE);
    }
  };

  if (!subcatOnly) {
    const catEls = document.querySelectorAll(`.${PANEL_CATEGORY}`);
    catEls.forEach(deactivateElement);
  }

  const subCatEls = document.querySelectorAll(`.${PANEL_SUBCATEGORY}`);
  subCatEls.forEach(deactivateElement);
};

const closeMenu = (e) => {
  e.stopPropagation();
  // Menu is already open
  document.querySelector(BODY)?.classList.remove('navOpen');
  // Mobile gets a timeout for it to slide shut before deactivating the content
  const closeTimeout = window.matchMedia(tabletMediaQuery).matches ? 0 : 300;
  document.querySelector(NAVIGATION)?.classList.remove(OPEN);
  document.querySelector(".header")?.classList.remove(OPEN);
  document.querySelector(NAVIGATION)?.classList.add(CLOSING);
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, false);
  if(closeTimeout == 300) {
    setTimeout(() => {
      closemenuwithsettimeout();
    }, closeTimeout);
  }else{
    closemenuwithsettimeout();
  }
};

const closemenuwithsettimeout = () => {
  document.querySelector(NAVIGATION)?.classList.remove(ACTIVE);
  document.querySelector(NAVIGATION)?.classList.remove(CLOSING);
  // Remove Open/Current Modifiers
  const panels = document.querySelectorAll(NAV_PANELS);
  panels.forEach((p) => p?.classList.remove(ACTIVE));

  const navButtons = document.querySelectorAll(NAV_BUTTONS);
  navButtons.forEach((b) => b?.setAttribute(ARIA_EXPANDED, false));

  document.querySelector('main')?.removeAttribute(ARIA_HIDDEN);
  document.querySelector('footer')?.removeAttribute(ARIA_HIDDEN);
  emitEvent(OPEN_NAV, { status: false, fromBurger: false });
};

const togglePanelClosed = (trigger, target, e) => {
  e.stopPropagation();
  if (target && document.querySelector(`#${target}.${ACTIVE}`)) {
    document.querySelector(`#${target}`)?.classList.remove(ACTIVE);
    trigger?.setAttribute(ARIA_EXPANDED, false);
    emitEvent(TOGGLE_PANEL, target);
  }
};

const getLastChildOfNavMenu = (event) => {
  let listOfsubcategory = document.querySelectorAll(`.${PANEL_SUBCATEGORY} ul`);
  for (const subcategory of listOfsubcategory) {
    for (const child of subcategory.children) {
      child.addEventListener('keydown', (event) => {
        if (event.code == 'Escape') {
          closeMenu(event);
        }
      });
    }
  }
  if (event.keyCode === 27) {
    closeMenu(event); 
  }
  let nextsibling = document.getElementById(
    event.target.id
  )?.nextElementSibling;
  if (nextsibling != null) {
    let nextElementChildrens = document.getElementById(event.target.id)
      ?.nextElementSibling.children;
    if (nextElementChildrens.length > 0) {
      let innerClass = nextElementChildrens[0];
      let details = innerClass?.children[3]?.children;
      for (let i = 0; i < details?.length; i++) {
        lastChild = details[details.length - 1].children[0].innerText;
      }
    }
  }
};

const closeMenuOnLastChild = (event) => {
  if (lastChild === event.target.innerText && event.key == 'Tab') {
    closeMenu(event);
  }
};

/**
 * Returns the visible category trigger inside a panel-toggle list item.
 */
const getCategoryTrigger = (container) => {
  if (!container) return null;

  if (container.matches?.('a.header-nav__nav-button.--category, button.header-nav__nav-button.--category')) {
    return container;
  }

  const desktopTrigger = container.querySelector('a.header-nav__nav-button.--category');
  if (desktopTrigger && window.getComputedStyle(desktopTrigger).display !== 'none') {
    return desktopTrigger;
  }

  return container.querySelector('button.header-nav__nav-button.--category');
};

/**
 * Set ARIA expanded attribute on category triggers or the element itself.
 */
const setAriaExpanded = (trigger, expanded) => {
  if (!trigger) return;

  const categoryTriggers = trigger.querySelectorAll(
    'a.header-nav__nav-button.--category, button.header-nav__nav-button.--category'
  );

  if (categoryTriggers.length) {
    categoryTriggers.forEach((categoryTrigger) => {
      categoryTrigger.setAttribute(ARIA_EXPANDED, expanded);
    });
    return;
  }

  if (trigger.matches?.('button, a')) {
    trigger.setAttribute(ARIA_EXPANDED, expanded);
  }
};

/**
 * Setup subcategory buttons and panel for tablet view
 */
const setupTabletSubcategories = (target) => {
  const hovertarget = document.querySelector(`#${target}`);
  const subcategoryButton = hovertarget.querySelectorAll('.header-nav__nav-button.--sub-category');
  const subcategoryPanel = hovertarget.querySelector('.header-nav__category-panel.--sub-category');
  
  subcategoryButton.forEach((subitem, i) => {
    subitem.setAttribute(ARIA_EXPANDED, i === 0);
  });
  
  if (subcategoryPanel != null) {
    subcategoryPanel.classList.add(ACTIVE);
  }
};

/**
 * Adjust container height based on viewport and content
 */
const adjustContainerHeight = (fixedContainer, viewportHeight, overallheight) => {
  if (overallheight >= viewportHeight) {
    fixedContainer.style.bottom = '0';
  } else {
    fixedContainer.style.bottom = 'unset';
    fixedContainer.style.overflowY = 'hidden';
    
    const subcontainer = document.getElementsByClassName('header-nav__category-panel --sub-category --active');
    if (subcontainer.length > 0) {
      const subcontainerheight = subcontainer[0].offsetHeight;
      const fixedContainerHeight = fixedContainer.querySelector('.header-nav__nav-list').offsetHeight;
      
      if (subcontainerheight > fixedContainerHeight) {
        const remainingHeight = overallheight - subcontainerheight;
        const fixedHeight = overallheight + remainingHeight;
        fixedContainer.firstElementChild.style.height = fixedHeight + 'px';
      }
    }
  }
};

/**
 * Handle tablet-specific panel adjustments
 */
const handleTabletPanelAdjustments = (target) => {
  setupTabletSubcategories(target);
  
  const fixedContainer = document.querySelector('.header-nav__category-panel.--category.--active');
  fixedContainer.style.bottom = 'unset';
  
  const viewportHeight = window.innerHeight;
  const overallheight = fixedContainer.getBoundingClientRect().height;
  
  adjustContainerHeight(fixedContainer, viewportHeight, overallheight);
};

const isDesktopNav = () => window.matchMedia(tabletMediaQuery).matches;

const togglePanelOpen = (trigger, target, { preserveFocus = false } = {}) => {
  if (!preserveFocus) {
    getCategoryTrigger(trigger)?.focus();
  }

  if (!target) {
    deactivatePanels(true);
    return;
  }

  if (document.querySelector(`#${target}.${ACTIVE}`)) {
    return;
  }

  const firstSubCat = openMenu(false, trigger);
  
  // Deactivate sibling panels
  if (trigger?.classList.contains(PANEL_CATEGORY) || getCategoryTrigger(trigger)) {
    deactivatePanels(false);
  }
  if (trigger?.classList.contains(PANEL_SUBCATEGORY)) {
    deactivatePanels(true);
  }

  // Opens first sub category if applicable
  if (firstSubCat) firstSubCat.click();
  
  document.querySelector(`#${target}`)?.classList.add(ACTIVE);
  setAriaExpanded(trigger, true);
  
  if (window.matchMedia(tabletMediaQuery).matches) {
    handleTabletPanelAdjustments(target);
  }
  
  emitEvent(TOGGLE_PANEL, target);
};

const toggleSearchClosed = () => {
  const searchButton = document.getElementById(SEARCH_BTN);
  searchButton?.setAttribute(ARIA_EXPANDED, false);
  searchButton
    ?.querySelector('svg>use')
    .setAttribute('xlink:href', SEARCH_ICON_HREF);

  const openLabel =
    searchButton.getAttribute('data-open-label') || DEFAULT_SEARCH_OPEN_LABEL;
  searchButton?.querySelector('svg')?.setAttribute('aria-label', openLabel);

  document.getElementById(MY_ACCOUNT_BTN)?.removeAttribute('tabindex');
  document.querySelector(SEARCH_PANEL)?.classList.remove(OPEN);
  document.querySelector(BODY)?.classList.remove('--openSearch');
  emitEvent(TOGGLE_SEARCH, { status: false });
};
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleSearchClosed();
  }
});
document.addEventListener('focusin', (event) => {
  const searchPanel = document.querySelector(SEARCH_PANEL);
  const searchButton = document.getElementById(SEARCH_BTN);
  if (
    searchPanel &&
    !searchPanel.contains(event.target) &&
    searchButton &&
    !searchButton.contains(event.target)
  ) {
    toggleSearchClosed();
  }
});
const toggleSearchPanel = (e) => {
  const searchPanel = document.querySelector(SEARCH_PANEL);
  const searchInput = document.querySelector(SEARCH_INPUT);
  if (searchInput) searchInput.value = '';
  if (!searchPanel?.classList.contains(OPEN)) {
    // Check if nav is open, and close it if needed
    if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
      closeMenu(e);
    }
    // Open Search Panel
    const searchButton = document.getElementById(SEARCH_BTN);
    searchButton?.setAttribute(ARIA_EXPANDED, true);
    const closeLabel =
      searchButton.getAttribute('data-close-label') ||
      DEFAULT_SEARCH_CLOSED_LABEL;
    searchButton?.querySelector('svg')?.setAttribute('aria-label', closeLabel);
    searchButton
      ?.querySelector('svg>use')
      .setAttribute('xlink:href', CLOSE_ICON_HREF);

    document.getElementById(MY_ACCOUNT_BTN)?.setAttribute('tabindex', '-1');

    pushEvent({
      event: 'uaevent',
      event_name: 'search_icon_click',
      ecommerce: 'undefined',
      click_area: 'header',
    });

    searchPanel?.classList.add(OPEN);
    document.querySelector(BODY)?.classList.add('--openSearch');
    searchInput.focus();
    emitEvent(TOGGLE_SEARCH, { status: true });
  } else {
    toggleSearchClosed();
  }
};

/**
 * Handler for burger button binding
 */
const handleBurgerBinding = (el) => {
  el.addEventListener('click', () => {
    openMenu(true);
  });
};

/**
 * Closes the desktop menu when focus leaves a category item and its panel.
 */
const handleDesktopPanelFocusOut = (el, event) => {
  requestAnimationFrame(() => {
    const nav = document.querySelector(NAVIGATION);
    if (!el.contains(document.activeElement)) {
      if (nav && nav.contains(document.activeElement)) {
        return;
      }
      closeMenu(event);
    }
  });
};

/**
 * Handler for panel toggle binding
 */
const handlePanelToggleBinding = (el, value) => {
  const panelId = value ? value.id : undefined;

  const openPanel = ({ preserveFocus = false } = {}) => {
    togglePanelOpen(el, panelId, { preserveFocus });
  };

  el.addEventListener('click', () => {
    openPanel();
  });

  el.addEventListener('mouseenter', () => {
    if (isDesktopNav()) {
      openPanel();
    }
  });

  el.addEventListener('focusin', () => {
    if (isDesktopNav()) {
      openPanel({ preserveFocus: true });
    }
  });

  if (isDesktopNav()) {
    el.addEventListener('mouseleave', (e) => {
      closeMenu(e);
    });

    el.addEventListener('focusout', (e) => {
      handleDesktopPanelFocusOut(el, e);
    });
  }

  el.addEventListener('keydown', (event) => {
    closeMenuOnLastChild(event);
  });

  el.addEventListener('keyup', (event) => {
    getLastChildOfNavMenu(event);
  });
};

/**
 * Handler for level 2 panel toggle binding
 */
const handleLevel2PanelToggleBinding = (el, value) => {
  const panelId = value ? value.id : undefined;

  const openPanel = ({ preserveFocus = false } = {}) => {
    togglePanelOpen(el, panelId, { preserveFocus });
  };

  el.addEventListener('click', () => {
    openPanel();
  });

  if (isDesktopNav()) {
    el.addEventListener('mouseenter', () => {
      openPanel();
    });

    el.addEventListener('focusin', () => {
      openPanel({ preserveFocus: true });
    });
  }
};

/**
 * Handler for back return binding
 */
const handleBackReturnBinding = (el, value) => {
  el.addEventListener('click', (e) => {
    togglePanelClosed(el, value ? value.id : undefined, e);
  });
};

/**
 * Handler for menu close binding
 */
const handleMenuCloseBinding = (el, value) => {
  el.addEventListener('click', (e) => {
    closeMenu(e);
  });
  
  el.addEventListener('mouseenter', (e) => {
    if (window.matchMedia(tabletMediaQuery).matches && value) {
      closeMenu(e);
    }
  });
};

/**
 * Handler for menu leave binding
 */
const handleMenuLeaveBinding = (el) => {
  el.addEventListener('mouseenter', (e) => {
    closeMenu(e);
  });
};

/**
 * Handler for search toggle binding
 */
const handleSearchToggleBinding = (el) => {
  el.addEventListener('click', () => {
    toggleSearchPanel();
  });
};

/**
 * Handler for search close binding
 */
const handleSearchCloseBinding = (el) => {
  el.addEventListener('click', () => {
    toggleSearchClosed();
  });
};

const headerNav = {
  name: 'headernav',
  inserted: (el, binding) => {
    const { arg, value } = binding;

    const handlers = {
      burger: () => handleBurgerBinding(el),
      paneltoggle: () => handlePanelToggleBinding(el, value),
      level2paneltoggle: () => handleLevel2PanelToggleBinding(el, value),
      backreturn: () => handleBackReturnBinding(el, value),
      menuclose: () => handleMenuCloseBinding(el, value),
      menuleave: () => handleMenuLeaveBinding(el),
      searchtoggle: () => handleSearchToggleBinding(el),
      searchclose: () => handleSearchCloseBinding(el),
    };

    const handler = handlers[arg];
    if (handler) {
      handler();
    }
  },
};

export {
  headerNav,
  emitEvent,
  openMenu,
  deactivatePanels,
  closeMenu,
  togglePanelClosed,
  togglePanelOpen,
  toggleSearchClosed,
  toggleSearchPanel,
  closeMenuOnLastChild,
  getLastChildOfNavMenu,
};